/* Ingredient Atlas: deterministic local enhancement. No requests or persistence. */
(() => {
  'use strict';
  const normalise = (value) => String(value).normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '').replace(/ł/g, 'l').replace(/Ł/g, 'L')
    .replace(/ß/g, 'ss').toLocaleLowerCase().replace(/\s+/g, ' ').trim();
  document.querySelectorAll('[data-v12-lookup]').forEach((root) => {
    if (root.dataset.v12Ready) return;
    const form = root.querySelector('[data-v12-name-form]');
    const input = form && form.querySelector('input');
    const reset = root.querySelector('[data-v12-name-reset]');
    const status = root.querySelector('[data-v12-name-status]');
    const empty = root.querySelector('[data-v12-name-empty]');
    const cards = Array.from(root.querySelectorAll('[data-v12-name]'));
    if (!form || !input || !reset || !status || !empty || !cards.length) return;
    let records;
    try {
      records = cards.map((card) => ({ card,
        aliases: JSON.parse(card.dataset.v12Aliases).map(normalise) }));
    } catch (_) { return; } // The complete static guide remains available.
    const update = (query) => {
      const name = normalise(query);
      let count = 0;
      records.forEach(({ card, aliases }) => {
        const match = !name || aliases.includes(name);
        card.hidden = !match;
        if (name && match) card.open = true;
        count += Number(match);
      });
      empty.hidden = count !== 0;
      root.dataset.v12Matches = String(count);
      status.textContent = status.dataset.v12CountTemplate.replace('{count}', String(count));
    };
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      update(input.value);
    });
    reset.addEventListener('click', () => {
      input.value = '';
      update('');
      input.focus();
    });
    // A browser's native search-clear control restores the complete guide.
    input.addEventListener('input', () => { if (!input.value.trim()) update(''); });
    root.dataset.v12Ready = 'true';
    form.hidden = false;
    status.hidden = false;
    update('');
  });
  document.querySelectorAll('[data-v12-label]').forEach((root) => {
    if (root.dataset.v12Ready) return;
    const controls = root.querySelector('[data-v12-label-filters]');
    const status = root.querySelector('[data-v12-label-status]');
    const buttons = Array.from(root.querySelectorAll('[data-v12-label-filter]'));
    const rows = Array.from(root.querySelectorAll('[data-v12-label-row]'));
    if (!controls || !status || !buttons.length || !rows.length) return;
    const update = (group) => {
      let count = 0;
      rows.forEach((row) => {
        row.hidden = group !== 'all' && row.dataset.v12Group !== group;
        count += Number(!row.hidden);
      });
      buttons.forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.v12LabelFilter === group));
      });
      status.textContent = status.dataset.v12CountTemplate.replace('{count}', String(count));
    };
    buttons.forEach((button) => {
      button.addEventListener('click', () => update(button.dataset.v12LabelFilter));
    });
    root.dataset.v12Ready = 'true';
    controls.hidden = false;
    status.hidden = false;
    update('all');
  });
})();

/* Bounded on-page tools. No upload, saved list, remote voice or autoplay. */
(() => {
  'use strict';
  const normalise = (value) => String(value).normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '').replace(/ł/g, 'l').replace(/Ł/g, 'L')
    .replace(/ß/g, 'ss').toLowerCase().replace(/\s+/g, ' ').trim();
  const element = (tag, text, className) => {
    const node = document.createElement(tag);
    if (text !== undefined) node.textContent = text;
    if (className) node.className = className;
    return node;
  };
  document.querySelectorAll('[data-v12-list-tool]').forEach((root) => {
    if (root.dataset.v12Ready) return;
    const source = root.querySelector('[data-v12-list-data]');
    const controls = root.querySelector('[data-v12-list-controls]');
    const input = root.querySelector('textarea');
    const button = root.querySelector('[data-v12-list-explain]');
    const status = root.querySelector('[data-v12-list-status]');
    const results = root.querySelector('[data-v12-list-results]');
    const fallback = root.querySelector('[data-v12-list-fallback]');
    if (!source || !controls || !input || !button || !status || !results) return;
    let data;
    const names = new Map();
    try {
      data = JSON.parse(source.textContent);
      if (data.dictionary.length !== 12) return;
      data.dictionary.forEach((record) => {
        if (!/^[a-z][a-z-]+$/.test(record.slug)) throw new Error('Invalid identity');
        record.aliases.forEach((alias) => {
          const key = normalise(alias);
          if (names.has(key) && names.get(key).slug !== record.slug) throw new Error('Ambiguous identity');
          names.set(key, record);
        });
      });
    } catch (_) { return; }
    const clear = () => { results.replaceChildren(); results.hidden = true; };
    button.addEventListener('click', () => {
      // Read only after an explicit action. Never rewrite the pasted source.
      const original = input.value;
      if (original.length > 5000) { clear(); status.textContent = data.texts.long; return; }
      const tokens = original.split(/[,;]/).filter((token) => token.trim());
      if (!tokens.length) { clear(); status.textContent = data.texts.empty; return; }
      if (tokens.length > 100) { clear(); status.textContent = data.texts.many; return; }
      const fragment = document.createDocumentFragment();
      let matched = 0;
      tokens.forEach((token, index) => {
        const record = names.get(normalise(token));
        const item = element('li', undefined, 'atlas-v12-list-item');
        item.value = index + 1;
        const detail = element('details');
        const summary = element('summary');
        summary.append(element('strong', token, 'atlas-v12-original-name'));
        summary.append(element('span', record ? data.texts.known : data.texts.unknown, 'atlas-v12-list-match'));
        detail.append(summary);
        const body = element('div', undefined, 'atlas-v12-list-body');
        if (record) {
          matched += 1;
          body.append(element('p', record.name, 'atlas-v12-list-everyday'));
          body.append(element('p', record.role));
          body.append(element('p', record.limit, 'atlas-v12-extras-small'));
          const link = element('a', data.texts.read + ' →');
          if (record.url) link.setAttribute('href', record.url);
          body.append(link);
        } else {
          body.append(element('p', data.texts.unknown_note));
        }
        detail.append(body);
        item.append(detail);
        fragment.append(item);
      });
      results.replaceChildren(fragment);
      results.hidden = false;
      status.textContent = data.texts.summary.replace('{matched}', String(matched))
        .replace('{unknown}', String(tokens.length - matched));
    });
    root.dataset.v12Ready = 'true';
    controls.hidden = false;
    if (fallback) fallback.hidden = true;
  });

  document.querySelectorAll('[data-v12-audio]').forEach((root) => {
    if (root.dataset.v12Ready) return;
    const controls = root.querySelector('[data-v12-audio-controls]');
    const play = root.querySelector('[data-v12-audio-play]');
    const pause = root.querySelector('[data-v12-audio-pause]');
    const stop = root.querySelector('[data-v12-audio-stop]');
    const status = root.querySelector('[data-v12-audio-status]');
    const answer = root.closest('#quick-answer');
    const title = answer && answer.querySelector('#quick-answer-title');
    const text = answer && (answer.querySelector('[data-v12-answer-text]') || (title && title.nextElementSibling));
    if (!controls || !play || !pause || !stop || !status || !title || !text || text.tagName !== 'P') return;
    let words;
    try { words = JSON.parse(root.dataset.v12AudioTexts); } catch (_) { return; }
    const language = root.dataset.v12Language;
    const synth = window.speechSynthesis;
    const Utterance = window.SpeechSynthesisUtterance;
    let active = null;
    let serial = 0;
    let state = 'idle';
    // Only voices explicitly reported as local, in the same base language.
    const voice = () => {
      if (!synth || typeof synth.getVoices !== 'function') return null;
      try {
        return synth.getVoices().find((candidate) => candidate.localService === true
          && String(candidate.lang).toLowerCase().split(/[-_]/)[0] === language) || null;
      } catch (_) { return null; }
    };
    const show = (message) => {
      play.disabled = Boolean(active) || !voice() || typeof Utterance !== 'function';
      pause.disabled = !active;
      stop.disabled = !active;
      pause.textContent = state === 'paused' ? words.resume : words.pause;
      pause.setAttribute('aria-pressed', String(state === 'paused'));
      status.textContent = message;
    };
    const finish = (message) => {
      active = null;
      state = 'idle';
      show(message);
    };
    const cancel = (message) => {
      const wasActive = Boolean(active);
      serial += 1;
      active = null;
      state = 'idle';
      if (wasActive && synth) synth.cancel();
      show(message);
    };
    controls.hidden = false;
    root.dataset.v12Ready = 'true';
    if (!synth || typeof Utterance !== 'function') { show(words.audio_unavailable); return; }
    play.addEventListener('click', () => {
      // Recheck at the user's click; never select a default/remote fallback.
      const selected = voice();
      if (!selected) { show(words.audio_unavailable); return; }
      const transcript = title.textContent.trim() + '\n' + text.textContent.trim();
      if (!transcript.trim()) { show(words.audio_error); return; }
      serial += 1;
      const current = serial;
      synth.cancel();
      if (synth.paused) synth.resume(); // cancel() does not reset the paused state.
      const utterance = new Utterance(transcript);
      utterance.voice = selected;
      utterance.lang = selected.lang;
      active = utterance;
      state = 'playing';
      utterance.onstart = () => { if (current === serial) show(words.audio_speaking); };
      utterance.onend = () => { if (current === serial) finish(words.audio_done); };
      utterance.onerror = () => { if (current === serial) finish(words.audio_error); };
      show(words.audio_speaking);
      try { synth.speak(utterance); } catch (_) { if (current === serial) finish(words.audio_error); }
    });
    pause.addEventListener('click', () => {
      if (!active) return;
      if (state === 'paused') {
        synth.resume(); state = 'playing'; show(words.audio_speaking);
      } else {
        synth.pause(); state = 'paused'; show(words.audio_paused);
      }
    });
    stop.addEventListener('click', () => cancel(words.audio_stopped));
    document.addEventListener('visibilitychange', () => {
      if (document.hidden && active) cancel(words.audio_stopped);
    });
    window.addEventListener('pagehide', () => { if (active) cancel(words.audio_stopped); });
    if (typeof synth.addEventListener === 'function') {
      synth.addEventListener('voiceschanged', () => {
        const available = voice();
        if (active && (!available || !synth.getVoices().some((candidate) => candidate.localService === true
          && candidate.voiceURI === active.voice.voiceURI && candidate.lang === active.voice.lang))) {
          cancel(words.audio_unavailable);
        } else if (!active) show(available ? words.audio_ready : words.audio_unavailable);
      });
    }
    show(voice() ? words.audio_ready : words.audio_unavailable);
  });
})();
